import { Language } from '../translations'

export const documentTranslations: Record<string, Record<Language, string>> = {
  fileType: {
    en: 'File Type',
    fi: 'Tiedostotyyppi'
  },
  fileSize: {
    en: 'File Size',
    fi: 'Tiedostokoko'
  },
  certificate: {
    en: 'Certificate',
    fi: 'Sertifikaatti'
  },
  linkedToCertificate: {
    en: 'Linked to certificate',
    fi: 'Linkitetty sertifikaattiin'
  },
  download: {
    en: 'Download',
    fi: 'Lataa'
  },
  documentDeletedSuccess: {
    en: 'Document deleted successfully',
    fi: 'Dokumentti poistettu onnistuneesti'
  },
  confirmDeleteDocument: {
    en: 'Are you sure you want to delete this document?',
    fi: 'Haluatko varmasti poistaa tämän dokumentin?'
  },
  noDocuments: {
    en: 'No documents found',
    fi: 'Dokumentteja ei löytynyt'
  },
  documentUploaded: {
    en: 'Document uploaded successfully',
    fi: 'Dokumentti ladattu onnistuneesti'
  },
  viewDocument: {
    en: 'View Document',
    fi: 'Näytä dokumentti'
  },
  changeDocument: {
    en: 'Change Document',
    fi: 'Vaihda dokumentti'
  },
  uploadDocument: {
    en: 'Upload Document',
    fi: 'Lataa dokumentti'
  },
  file: {
    en: 'File',
    fi: 'Tiedosto'
  },
  noFile: {
    en: 'No file uploaded',
    fi: 'Ei ladattua tiedostoa'
  },
};